module.exports = __webpack_public_path__ + "img/title-7-142167.png";